import {Action} from '@ngrx/store';
import {Group} from '../../../models/group';
import {BijbEvent} from '../../../models/bijb-event';

export class AddGroupAction implements Action {
  public static readonly type = 'AddGroupAction';

  constructor(public bijbEvent: BijbEvent, public group: Group) {
  }

  public type = AddGroupAction.type;
}
